<div class="h-100" *ngIf="(nameComponentLin == 'LISTAR')">
  <app-geocerca-polyline-lists></app-geocerca-polyline-lists>
</div>

<div class="h-100" *ngIf="(nameComponentLin == 'AGREGAR')">
  <app-geocerca-polyline-add></app-geocerca-polyline-add>
</div>